export const IMAGE_POSTFIX = "_w400"
export const IMAGE_POSTFIX_MOBILECARD = "_mobilecard"
export const IMAGE_POSTFIX_WEBCARD = "_webcard"
export const IMAGE_POSTFIX_WEBFULL = "_webfull"
export const BLUR_POSTFIX = "_blr"

export const FALLBACK_LOGO_IMAGE = `${
  process.env.REACT_APP_BASENAME || ""
}/images/placeholder.jpg`
